module.exports = __webpack_public_path__ + "img/kommune-937.4bdaf2b8.svg";